import { Log, UserManager } from 'oidc-client-ts';
import oidcConfig from '../Configuration/OidcConfiguration';

Log.setLogger(console);

// console.info(`Creating user manager with options: ${JSON.stringify(oidcConfig, null, 2)}`);
export const userManager = new UserManager({ ...oidcConfig });

export const handleCallback = async () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

export const setActiveUserId = (userId: string): void => {
  localStorage.setItem('active-user-id', userId);
};

export const getActiveUserId = (): string => {
  return localStorage.getItem('active-user-id') ?? '';
};

export const setActiveCustomerId = (userId: string): void => {
  localStorage.setItem('active-customer-id', userId);
};
